import { render, staticRenderFns } from "./VIRTUAL.vue?vue&type=template&id=b3df724c&"
import script from "./VIRTUAL.vue?vue&type=script&lang=js&"
export * from "./VIRTUAL.vue?vue&type=script&lang=js&"
import style0 from "./VIRTUAL.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports